module.exports = __webpack_public_path__ + "images/bug_turquoise_size_5_a6d98798b898c282ce6f1d83ae3730d5.png";